import React from 'react';
import { Box, Typography } from '@mui/material';

export default function PointsPage() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" sx={{ mb: 3, fontWeight: 600 }}>
        Puntos
      </Typography>
      <Typography variant="body1">
        Esta es la página de puntos. Aquí se mostrará el contenido relacionado con los puntos.
      </Typography>
    </Box>
  );
}
